import React from 'react';

import ListResource from '../ListResource.jsx';
import ListCtrlActivates from '../ListCtrlActivates.jsx';

const api = '/api/core/tfy/suppliers';

const ListSuppliers = () => (
  <ListResource
    {...{
      searchable: true,
      api,
      sort: { name: 1 },
      actions: {
        fileExport: true,
        fileImport: true,
      },
      cols: [
        {
          key: 'name',
          sortable: true,
          children: 'Name',
          headerStyle: {
            width: '45%',
          },
        },
        {
          key: 'address',
          sortable: true,
          children: 'Address',
          headerStyle: {
            width: '45%',
          },
        },
      ],
    }}
  >
    {({ selected, refresh }) => (
      <ListCtrlActivates
        api={api}
        selected={selected}
        onSuccess={refresh}
      />
    )}
  </ListResource>
);

export default ListSuppliers;
